import axios from '@/plugins/axios'
import { Module } from 'vuex'

export interface AuditLog {
    username: string
    token: string
}

const auditLogModule: Module<any, any> = {
    state: {
        logs: [],
        totalRows: 0,
    },
}

export default auditLogModule
